/* eslint-disable no-unused-vars */
import axios from 'axios';
import MockApi from './MockApi';
import serviceTimes from '../../fixtures/apiResponses/serviceTimes.json';
import apiEndpoints from '../globals/apiEndpoints';

export default class ServiceTimes {
	static fetch({ addressId, day, duration }) {
		 // Форматирование даты в строку в формате, сохраняющем локальное время
		 const formattedLocalDay = `${day.getFullYear()}-${(day.getMonth() + 1).toString().padStart(2, '0')}-${day.getDate().toString().padStart(2, '0')}T${day.getHours().toString().padStart(2, '0')}:${day.getMinutes().toString().padStart(2, '0')}:${day.getSeconds().toString().padStart(2, '0')}`;
		 return axios.get(apiEndpoints.serviceTimes, { params: { addressId, day: formattedLocalDay, duration } });
	   }
		//return MockApi.get({ data: serviceTimes, timeout: 800 });
}
